<!--<script src="../claim-view-attachments-list/claim-view-attachments-list.component.ts"></script>!-->
<div class="main-container" *ngIf="!isLoading" data-cy="financial-snapshot-detail-container">
  <div class="section-header" data-cy="financial-snapshot-detail-header">
    <div class="section-header-title" data-cy="financial-snapshot-detail-title">Snapshot Detail Report From {{this.initialDate}} To {{this.endDate}}
      : {{conceptDetail}}</div>
  </div>
  <div style="flex: 1; overflow-y: auto; overflow-x: auto;height: 500px; margin-top: 2px; padding: 0px 10px 10px 10px" data-cy="financial-snapshot-detail-content">
    <tdo-table [dataSource]="conceptBreakdownDetails" [sortPredicate]="sortPredicate"
               [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="false"
               [searchPredicate]="searchPredicate" [HasRowNumbers]="true"
               (rowSelected)="onRowSelected($event)" [footerData]="footerData" data-cy="financial-snapshot-detail-table">

      <tdo-table-column displayName="No" propertyName="No" isSortable="true" [rowTemplate]="rowNumber" data-cy="financial-snapshot-detail-column-no">
        <ng-template #rowNumber let-row>
          <div data-cy="financial-snapshot-detail-row-number">{{ row.model.rowNumber }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="PT ID #" propertyName="PatientNO" isSortable="true" [rowTemplate]="PatientNO" data-cy="financial-snapshot-detail-column-patient-no">
        <ng-template #PatientNO let-row>
          <div data-cy="financial-snapshot-detail-patient-no">{{ row.model.PatientNO }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Patient" propertyName="PatientName" isSortable="true" [rowTemplate]="PatientName" data-cy="financial-snapshot-detail-column-patient-name">
        <ng-template #PatientName let-row>
          <div *ngIf="row.model.PatientName" data-cy="financial-snapshot-detail-patient-name">{{ row.model.PatientName }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Tooth" propertyName="Tooth" isSortable="true" [rowTemplate]="tooth" data-cy="financial-snapshot-detail-column-tooth">
        <ng-template #tooth let-row>
          <div *ngIf="row.model.Tooth" data-cy="financial-snapshot-detail-tooth">{{ row.model.Tooth }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Code" propertyName="Code" isSortable="true" [rowTemplate]="code" data-cy="financial-snapshot-detail-column-code">
        <ng-template #code let-row>
          <div *ngIf="row.model.Code" data-cy="financial-snapshot-detail-code">{{ row.model.Code }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Referring Doctor" propertyName="ReferringDoctor" isSortable="true"
                        [rowTemplate]="referringDoctor" data-cy="financial-snapshot-detail-column-referring-doctor">
        <ng-template #referringDoctor let-row>
          <div *ngIf="row.model.ReferringDoctor" data-cy="financial-snapshot-detail-referring-doctor">{{ row.model.ReferringDoctor }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Date" isSortable="true" propertyName="Date" [rowTemplate]="Date" style="width: 120px" data-cy="financial-snapshot-detail-column-date">
        <ng-template #Date let-row style="width: 120px">
          <div *ngIf="row.model.Date" style="width: 120px" data-cy="financial-snapshot-detail-date"></div>
          {{ row.model.Date | date }}
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Amount" isSortable="true" propertyName="Amount" [rowTemplate]="Amount" data-cy="financial-snapshot-detail-column-amount">
        <ng-template #Amount let-row>
          <!--<div *ngIf="row.model.Amount" style="text-align: center">!-->
          <div *ngIf="row.model.Amount" data-cy="financial-snapshot-detail-amount">
            {{ row.model.Amount | currency }}
          </div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Comments" isSortable="true" propertyName="Comments" [rowTemplate]="Comments" style="width: 250px" data-cy="financial-snapshot-detail-column-comments">
        <ng-template #Comments let-row style="width: 250px">
          <div *ngIf="row.model.Comments" style="width: 250px" data-cy="financial-snapshot-detail-comments"></div>
          {{ row.model.Comments }}
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="View" propertyName="PatientId" [rowTemplate]="ledgerView" data-cy="financial-snapshot-detail-column-view">
        <ng-template #ledgerView let-row>
          <div *ngIf="row.model.PatientId" data-cy="financial-snapshot-detail-ledger-view">
            <button mat-icon-button color="primary" aria-label="View Ledger" (click)="this.openLedger(row.model)" data-cy="financial-snapshot-detail-view-ledger-button">
              <mat-icon [matTooltip]="'View Ledger'" data-cy="financial-snapshot-detail-view-ledger-icon">visibility</mat-icon>
            </button>
          </div>
        </ng-template>
      </tdo-table-column>
    </tdo-table>
  </div>
  <button mat-button class="tdo-button tdo-save button_Position" (click)="exportToExcel()" matTooltip="Export to Excel" data-cy="financial-snapshot-detail-export-button">
    Export to Excel
  </button>
</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="financial-snapshot-detail-loading">
  <mat-spinner data-cy="financial-snapshot-detail-spinner"></mat-spinner>
</div>
